var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"12","viewBox":"0 0 10 12"}},[_c('path',{attrs:{"d":"M9.65625 4L5 8.65625L0.34375 4H3V0H7V4H9.65625ZM4.34375 5.34375H3.5625L5 6.78125L6.4375 5.34375H5.65625V1.34375H4.34375V5.34375ZM0.34375 10V11.3438H9.65625V10H0.34375Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }